import { AppNavigation } from '../interfaces/navigation.interface';

export const selectTopNavigation = (state: AppNavigation[]): AppNavigation[] =>
  state.filter(
    (item: AppNavigation) => item.tags?.split(',').indexOf('top') !== -1,
  );

export const selectLeftNavigation = (state: AppNavigation[]): AppNavigation[] =>
  state.filter(
    (item: AppNavigation) => item.tags?.split(',').indexOf('left') !== -1, //&& item.tags?.indexOf("top") === -1
  );

export const selectNavigationById = (id: string) => (state: AppNavigation[]) =>
  state.find((item: AppNavigation) => item.id === id);
